import { render, staticRenderFns } from "./Iframe1.vue?vue&type=template&id=666f1c17&"
import script from "./Iframe1.vue?vue&type=script&lang=js&"
export * from "./Iframe1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports